import Banner from '../../../Assets/Images/DashboardMigrants/Capa_1-2.png'
import { Link } from 'react-router-dom'

const MigrantsBanner = ({ showButton = true, path = '/dashboard' }) => {
  return (
    <div className="migrants-banner row">
      <div className="image-banner col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <img src={Banner} alt="migrants-banner" />
      </div>
      <div className="banner-content col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <div className="banner-text">
          <h5 className="title-migrates">Acerca del portal</h5>
          <p className="text-migrates">
            Somos un portal de servicios vinculados a distintas dependencias del
            Gobierno de Jalisco, para brindar atención integral a todas las
            personas migrantes.
          </p>
          {showButton && (
            <div className="button-container">
              <Link className="btn btn-migrates" to={path}>
                Ingresar
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MigrantsBanner
